import { useState } from "react";
import { AlertCircle, Film, Loader2 } from "lucide-react";

type EvidenceVideoPlayerProps = {
  url: string;
  className?: string;
  /** Compact thumb in grid vs full player */
  compact?: boolean;
};

/**
 * V6 — Putar video bukti di facility_modul (streaming, tanpa download wajib).
 */
const EvidenceVideoPlayer = ({
  url,
  className = "",
  compact = false,
}: EvidenceVideoPlayerProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (!url || error) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-2 rounded-xl border border-slate-200 bg-slate-100 text-slate-500 ${
          compact ? "aspect-square" : "min-h-[180px] w-full"
        } ${className}`}
      >
        <AlertCircle className="h-6 w-6 text-red-400" />
        <span className="px-3 text-center text-xs">
          {error ? "Gagal memuat video" : "URL video kosong"}
        </span>
      </div>
    );
  }

  return (
    <div
      className={`relative overflow-hidden rounded-xl bg-black ${
        compact ? "aspect-square" : "w-full"
      } ${className}`}
    >
      {loading && (
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 bg-slate-900/80 text-white">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span className="text-xs">Memuat video…</span>
        </div>
      )}
      <video
        src={url}
        controls
        playsInline
        preload="metadata"
        className={`w-full object-contain ${compact ? "h-full" : "max-h-[min(50vh,360px)]"}`}
        onLoadedData={() => setLoading(false)}
        onCanPlay={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
      >
        Browser Anda tidak mendukung pemutar video.
      </video>
      {!loading && compact && (
        <div className="pointer-events-none absolute left-2 top-2 rounded-full bg-black/60 px-2 py-0.5 text-[10px] font-semibold text-white backdrop-blur-sm">
          <Film className="mr-1 inline h-3 w-3" />
          Video
        </div>
      )}
    </div>
  );
};

export default EvidenceVideoPlayer;
